import axios from 'axios'
import store from '@/state/store'

let _authAxiosBackend = null;
let _axiosBackend = null;
let _axiosBackendMubinApi = null;

export function initAxiosBackend(config = {}) {
    _authAxiosBackend = axios.create({
        baseURL: config.baseURL,
        headers: {
            'accept': 'application/json',
        }
    })

    _axiosBackendMubinApi = axios.create({
        baseURL: config.baseURLMubinApi,
        headers: {
            'accept': 'application/json',
        }
    })
     

    _axiosBackend = _authAxiosBackend
}

export function  getAuthAxiosBackend() {
    _authAxiosBackend.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters['auth/getToken']
    return _authAxiosBackend
}

export function  getAxiosBackend() {
    return _axiosBackend
}

export function  getAxiosBackendMubinApi() {
    return _axiosBackendMubinApi
}